import { createFileRoute } from "@tanstack/react-router";

import { WhatsAppGroupDetailPage } from "@/pages/Admin/WhatsAppGroupDetailPage";

export const Route = createFileRoute("/app/admin/whatsapp-groups/$groupId")({
  component: WhatsAppGroupDetailRoute,
});

function WhatsAppGroupDetailRoute() {
  const { groupId } = Route.useParams();
  return <WhatsAppGroupDetailPage groupId={groupId} />;
}
